export default "__VITE_ASSET__43f4c4a7__"